import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Color from '../../styles/common/Color';
import { ReactComponent as BaseCheckIcon } from '../../images/common/check_fill.svg';
import { ReactComponent as BaseErrorIcon } from '../../images/common/error_fill.svg';
import { ReactComponent as BaseNotSubjectIcon } from '../../images/common/not_subject_fill.svg';

const Check = styled(BaseCheckIcon)`
  width: 20px;
  height: 20px;
  margin-left: 5px;
  fill: ${Color.green};
  vertical-align: middle;
`;

const Error = styled(BaseErrorIcon)`
  width: 20px;
  height: 20px;
  margin-left: 5px;
  fill: ${Color.red};
  vertical-align: middle;
`;

const NotSubject = styled(BaseNotSubjectIcon)`
  width: 20px;
  height: 20px;
  margin-left: 5px;
  fill: ${Color.white};
  vertical-align: middle;
`;

const Description = styled.div`
  display: none;
  position: absolute;
  padding: 10px;
  font-size: 12px;
  line-height: 1.6em;
  color: ${Color.white};
  border-radius: 5px;
  background: ${Color.darkNavyBlue};
  width: 180px;

  :before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    border: 15px solid transparent;
    border-top: 15px solid ${Color.darkNavyBlue};
    margin-left: -15px;
  }
`;

const Block = styled.span`
  position: relative;

  &
    ${Check}:hover
    + ${Description},
    &
    ${Error}:hover
    + ${Description},
    &
    ${NotSubject}:hover
    + ${Description} {
    display: inline-block;
    left: -75px;
  }

  & ${Check}:hover + ${Description} {
    top: -60px;
  }
  & ${Error}:hover + ${Description} {
    top: -75px;
  }
  & ${NotSubject}:hover + ${Description} {
    top: -60px;
  }
`;

export const CheckIcon = ({ msg }) => (
  <Block>
    <Check />
    <Description>
      <span>{msg}</span>
    </Description>
  </Block>
);

export const ErrorIcon = ({ msg }) => (
  <Block>
    <Error />
    <Description>
      <span>{msg}</span>
    </Description>
  </Block>
);

export const NotSubjectIcon = ({ msg }) => (
  <Block>
    <NotSubject />
    <Description>
      <span>{msg}</span>
    </Description>
  </Block>
);

CheckIcon.propTypes = {
  msg: PropTypes.string.isRequired,
};

ErrorIcon.propTypes = {
  msg: PropTypes.string.isRequired,
};

NotSubjectIcon.propTypes = {
  msg: PropTypes.string.isRequired,
};
